import { Icon, Link } from "@chakra-ui/react"
import { FaDownload } from "react-icons/fa6"
import { useApi } from "../hooks/useApi";
import { useContext } from "react";
import { NotificationContextType } from "../types";
import { NotificationContext } from "./NotificationPane";
import { saveAs } from "file-saver";
import Papa from "papaparse";

type ExtractSupplyDataProps = {
  supplyNumber: string;
}

function ExtractSupplyData({supplyNumber}: ExtractSupplyDataProps) {
  const { ready, getSupplyHHExtraction } = useApi();
  const { pushNotification } = useContext<NotificationContextType | null>(NotificationContext)!;

  async function handleClick(){
    try {
      const response = await getSupplyHHExtraction(supplyNumber);
      if (!(response.length > 0)) return pushNotification("No data for supply.", "error");
      const csv = Papa.unparse(response);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${supplyNumber}.csv`);
    } catch(err) {
      pushNotification("Could not load chart data.", "error")
    }
  }

  if (!ready) return <></>
  return (
    <Link color='teal.500' href='#' onClick={handleClick}>Download CSV <Icon as={FaDownload}/></Link>
  )
}

export default ExtractSupplyData